import { render, staticRenderFns } from "./Projectteam.vue?vue&type=template&id=7677e487&"
import script from "./Projectteam.vue?vue&type=script&lang=js&"
export * from "./Projectteam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports